import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ErrorMessage.module.scss";

export type ErrorMessageProps = PlatformComponentProps & {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onClick?: () => void;
};

const COMPONENT_KEY = CoreUiComponents.ErrorMessage;

export const ErrorMessage = ({
  className,
  title,
  subtitle,
  buttonText,
  onClick,
  children,
}: ErrorMessageProps) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const titleCopy = title ?? t("genericShopErrorTitle");
  const subtitleCopy = subtitle ?? t("genericShopErrorSubtitle");
  const buttonCopy = buttonText ?? t("genericShopErrorButton");

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{titleCopy}</div>
      <div className={cn("subtitle")}>{subtitleCopy}</div>
      {onClick != null ? (
        <Button onClick={onClick} className={cn("button")}>
          {buttonCopy}
        </Button>
      ) : null}
      {children}
    </div>
  );
};
